import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PremiumMessage.css';
import Nav from '../../components/Nav/Nav'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../../features/currentUser'
import { Oval, MagnifyingGlass } from 'react-loader-spinner'
import { boughtPremiumMessage, getCurrentUserFinancials, getGroupById, getPostWithId, getPremiumMessageById, getUserInfoWithId, getUserProfileInfoWithId, unsubFinancials } from '../../services/f';
import { FaComment, FaShare } from 'react-icons/fa'
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';
import { PiUserCircleLight } from 'react-icons/pi'
import Footer from '../../components/Footer';
import { auth, db, functions } from '../../firebase';
import VerifyEmailComponent from '../../components/rememberverifyemail';
import { Helmet } from 'react-helmet';
import { TwitterShareButton } from 'react-twitter-embed';
import { HiOutlineLockClosed } from "react-icons/hi";
import PaypalBuyImmediatelyBtn from '../../components/PaypalBuyImmediatelyBtn/PayPalBuyImmediatelyBtn';
import PaypalBuyImmediatelyBtnNotLoggedIn from '../../components/PaypalBuyImmediatelyBtnNotLoggedIn/PaypalBuyImmediatelyBtnNotLoggedIn';
import { httpsCallable } from 'firebase/functions';
import { useResizeObserver } from '@wojtekmaj/react-hooks';
import { pdfjs, Document, Page } from 'react-pdf';
import VideoPlayerBoughtPM from '../../components/VideoPlayer/VideoPlayerBoughtPM';
import StripeBuyImmediatelyBtnNotLoggedIn from '../../components/StripeBuyImmediatelyBtnNotLoggedIn/StripeBuyImmediatelyBtnNotLoggedIn';
import StripeBuyImmediatelyBtn from '../../components/StripeBuyImmediatelyBtn/StripeBuyImmediatelyBtn';
import { stripePromise } from '../../App';
import {
  Elements, useStripe,
  useElements,
  ElementsConsumer,
} from '@stripe/react-stripe-js';
import PayWithSavedCards from '../ProfileScreen/StripeFolder/PayWithSavedCards';
import { doc, getDoc } from 'firebase/firestore';


pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

const resizeObserverOptions = {};

const maxWidth = 800;

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

const InjectedPayWithSavedCard = ({ pmitem, amount }) => (
  <ElementsConsumer>
    {({ stripe, elements, stripeuser }) => (
      <PayWithSavedCards stripe={stripe} pmitem={pmitem} elements={elements} amount={amount} />
    )}
  </ElementsConsumer>
);

//see which one google indees and which notif there are dofferences
//check faq pmitem app profile
function PremiumMessage() {
  // http://localhost:3000/pm?id=8XNWZWyYVJ1KAJhpw2m4
  // http://localhost:3000/pm?id=8XNWZWyYVJ1KAJhpw2m4

  // https://premsi.com/boughtpm?email=vanaprogr@gmail.com&id=8XNWZWyYVJ1KAJhpw2m4
  const [searchParams, setSearchParams] = useSearchParams();
  let currentUser = useSelector(getCurrentUser).currentUser?.currentUser// ALSO WENNS n user gibt dann wird anderes screen angezeigt
  const navigate = useNavigate()

  const [pmitem, setpmitem] = useState(null);
  const [financials, setfinancials] = useState();

  const [copiedlink, setcopiedlink] = useState(false);
  const [loading, setloading] = useState(false);
  const [boughtpmerror, setboughtpmerror] = useState(false);
  const [boughtsuccess, setboughtsuccess] = useState(false);

  const [email, setemail] = useState("");
  const [isemail, setisemail] = useState(true);

  const [pw, setpw] = useState("");

  const [buypm, setbuypm] = useState(false);
  const [showpp, setshowpp] = useState(false);

  // for pdf
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [containerRef, setContainerRef] = useState(null);
  const [containerWidth, setContainerWidth] = useState();

  // to show all premiumposts in an array when pm free
  const [retrievedpm, setretrievedpm] = useState(null);
  const [loadingerror, setsetloadingerror] = useState(false);
  const [isnotfree, setisnotfree] = useState(false);
  const [loadingpm, setloadingpm] = useState(false);
  const [arrayofmedia, setarrayofmedia] = useState([]);
  const [userProfile, setuserProfile] = useState(null);
  const stripe = useStripe()
  // for payment method choose
  const [buymethod, setbuymethod] = useState(0);
  const [stripeuser, setstripeuser] = useState(null);

  //following for paymentintent that created
  const [paymentIntent, setpaymentIntent] = useState(null);
  const [loadingClientSecret, setloadingClientSecret] = useState(false);


  const onResize = useCallback((entries) => {
    const [entry] = entries;
    //console.log("resized", entry.contentRect.width)

    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  useResizeObserver(containerRef, resizeObserverOptions, onResize);

  let titledescription
  let titletext

  function onDocumentLoadSuccess({ numPages }) {
    //console.log("this isnumPages", numPages)
    setNumPages(numPages);
  }

  useEffect(() => {
    let pmid = searchParams.get("id")
    if (pmid === null || pmid === undefined || pmid === "") {
      setpmitem("pmnotexists")
    } else {
      getPremiumMessageById(pmid).then((res) => {
        console.log("getPostWithId result", res)
        setpmitem(res)
        if (res === "pmnotexists") {
          return
        }
        getUserProfileInfoWithId(res[1].creator).then((res) => {
          console.log("getUserProfileInfoWithId result", res.bannerBgImage)
          setuserProfile(res)
        })
        if (auth.currentUser !== null) {
          getDoc(doc(db, "stripe_customers", auth.currentUser.uid)).then((stripecustomer) => {
            if (stripecustomer.exists()) {
              //console.log(stripecustomer.data())
              setstripeuser(stripecustomer.data())
            } else {
              console.log("No stripe customer was found")
              return
            }
          })
        }
        titledescription = "Premium Message description:  " + res[1]?.description + "Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute."
        titletext = "Premsi - Premium Message: " + res[1]?.grouptitle
      })
    }

  }, []);

  useEffect(() => {
    if (auth.currentUser === null || auth.currentUser === undefined) {
      return
    } else {
      if (buypm === true) {
        ////console.log("get financials")
        getCurrentUserFinancials(setfinancials)
        return () => {
          ////console.log("screen gone")
          unsubFinancials()
        }
      } else {
        return
      }
    }
  }, [buypm]);

  const buypmmessage = () => {
    //console.log("bus message")
    setloading(true)
    boughtPremiumMessage(auth.currentUser.uid, pmitem[1], pmitem[0]).then((message) => {
      //console.log("boughtPremiumMessage", message)
      if (message === "success") {
        //console.log("bought")
        setboughtsuccess(true)
        setloading(false)
      } else {
        setboughtpmerror(true)
        setloading(false)
      }
    })
  }

  useEffect(() => {
    console.log("restrievedpm useeffect", retrievedpm)
    let i = 0
    let farray = []

    if (retrievedpm === null) {
      return
    } else {
      while (i < retrievedpm?.data.amountfiles) {
        farray.push(retrievedpm?.data.media[i])
        i++
      }
      setarrayofmedia(farray)
    }
  }, [retrievedpm]);

  const unlock = () => {
    console.log("unlock it", pmitem, auth.currentUser)
    setloadingpm(true)
    setisnotfree(false)

    const checkpmbackend = httpsCallable(functions, 'retrieveandcheckfreePM');
    checkpmbackend({ pmid: pmitem[0], user: (auth.currentUser === null ? null : auth.currentUser.uid) })
      .then((result) => {
        // Read result of the Cloud Function.
        //console.log("resulttt checkpmbackend", result.data)
        if (result.data === "isnotfree") {
          setisnotfree(true)
          setloadingpm(false)
        } else {
          console.log("resulttt checkpmbackend", result)
          setretrievedpm(result.data)
          setloadingpm(false)
        }
      })
      .catch((error) => {
        // Getting the Error details.
        const code = error.code;
        const message = error.message;
        const details = error.details;
        //console.log("errorcloudfunction", error)
        //if response is error let user know with alert or so
        setsetloadingerror("there is an error on baclend")
        setloadingpm(false)
      });
  }

  //take all functions that open in PremiumMessageBought.js

  const freenotloggedin = () => {
    console.log("free but not logged in, just show it here get from backend and increment bought by 1 for creator")
    // so retreive from backend send it to frontend and once its here set it into a usestate and show it then here instead of the lock sign
    unlock()
  }

  const freeloggedin = () => {
    console.log("free and logged in, add to catalogue bought and show it here and increment bought by 1 for creator")
    // so retreive from backend send it to frontend and once its here set it into a usestate and show it then here instead of the lock sign
    // and then in backend add the premiummessage to user so that he sees in app also
    unlock()
  }

  useEffect(() => {
    //console.log("email", email)
    // don't remember from where i copied this code, but this works.
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      // this is a valid email address
      setisemail(true)
    }
    else {
      // invalid email, maybe show an error to the user.
      setisemail(false)
    }
  }, [email]);

  const getClientSecretForNewPaymentIntent = () => {
    setloadingClientSecret(true)
    console.log(stripeuser)
    const stripeclientsecret = httpsCallable(functions, 'getstripeclientsecretforpmloggedinFirstFunction');
    stripeclientsecret({ customerid: stripeuser.customer_id, amount: Number(pmitem[1].price), user: auth.currentUser.uid })
      .then(async (res) => {
        console.log("res", res.data.client_secret)
        setpaymentIntent(res.data.client_secret)
        setloadingClientSecret(false)
      }).then(() => setbuymethod(2))
  }


  //here add bannerBgImage by searching photoUrl and find out where could add banner AND PHOTOURL
  return (
    <div className='postscreenpm'>
      <Helmet>

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Premsi | Premium Message - Easily sell your digital content❤️" />
        <meta property="og:description" content="Premsi | Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
        <meta property="og:url" content="https://premsi.com/pm" />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
        <meta property="og:site_name" content="Premsi - sell digital content" />
        <link rel="canonical" href="https://premsi.com/pm" />

        <title>{titletext}</title>
        <meta name="description" content={String(titledescription)} />

        <meta name="twitter:title" content="Premsi" />
        <meta name="twitter:description" content={`Premsi.com Premium Message`} />
        <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Nav />
      {auth.currentUser === null || auth.currentUser === undefined || auth.currentUser.emailVerified === true ? null : <VerifyEmailComponent />}

      <div className="body">
        <div className='postscreen__bodypm'>

          <div className='topbannerprofile'>
            {userProfile?.bannerBgImage === "" || userProfile?.bannerBgImage === null || userProfile?.bannerBgImage === undefined
              ?
              <>
                {/*<img loading="lazy" style={{ pointerEvents: "none", objectFit: "cover" }} className='avatar_profilebanner' src={require('../../images/pres1.png')} alt="Premsi user pic" />*/}
              </>
              :
              <img loading="lazy" style={{ pointerEvents: "none" }} className='avatar_profilebanner' src={userProfile?.bannerBgImage} alt="Premsi user pic" />
            }

            {userProfile?.photoUrl === "" || userProfile === null || userProfile === undefined
              ?
              <div className='avatar_nopic_profile_div' style={{ marginTop: (userProfile?.bannerBgImage === "" || userProfile?.bannerBgImage === null || userProfile?.bannerBgImage === undefined ? 90 : -40) }}>
                <PiUserCircleLight className='avatar_nopic_profile' size={50} color='#fff' alt='no profile picture' />
              </div>
              :
              <div className='avatar_nopic_profile_div' style={{ marginTop: (userProfile?.bannerBgImage === "" || userProfile?.bannerBgImage === null || userProfile?.bannerBgImage === undefined ? 90 : -40) }}>
                <img loading="lazy" style={{ pointerEvents: "none" }} className='avatar_profile' src={userProfile?.photoUrl} alt="Premsi user pic" />
              </div>
            }
          </div>

          {pmitem === null ?
            <div>
              <Oval
                height={40}
                width={40}
                color="#009FFD"
                wrapperStyle={{ marginTop: 20, flex: "display", alignItems: "center", justifyContent: "center" }}
                wrapperClass=""
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="white"
                strokeWidth={5}
                strokeWidthSecondary={5}
              />
              <p style={{ marginBottom: 3, textAlign: "center", color: "white" }}>Loading premium message...</p>
              <p style={{ textAlign: "center", fontSize: 12, color: "white" }}>If this takes too long please refresh this window.</p>
            </div>
            :
            (
              pmitem === "pmnotexists"
                ?
                <div>
                  <MagnifyingGlass
                    height={40}
                    width={40}
                    color="#009FFD"
                    wrapperStyle={{ marginTop: 20, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
                    wrapperClass=""
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor="white"
                    strokeWidth={5}
                    strokeWidthSecondary={5}
                  />
                  <h1 style={{ marginBottom: 3, textAlign: "center", color: "black", fontSize: 17 }}>No Premium Message...</h1>
                  <p style={{ textAlign: "center", fontSize: 12, marginTop: 20 }}>It seems that you have a wrong link and this Premium Message doesn't exist</p>
                  <p style={{ textAlign: "center", fontSize: 12 }}>Please recheck your link.</p>
                  <div style={{ display: "flex", alignItems: "center", marginTop: 20, justifyContent: "center", width: "100%", marginBottom: 5 }}>
                    <button onClick={() => navigate("/alternativehomepage")} style={{ fontSize: 14, fontWeight: "bold", paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderRadius: 10, backgroundColor: "#009FFD", color: "white", borderWidth: 0 }}>Explore others</button>
                  </div>
                </div>
                :
                <>
                  {/* ── Card Header ── */}
                  <div className="pm-card-header">
                    <div className="pm-badge-premium">
                      <svg className="pm-badge-star" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l2.09 6.26H21l-5.47 3.97 2.09 6.26L12 14.52l-5.62 3.97 2.09-6.26L3 8.26h6.91z"/>
                      </svg>
                      Premium Message
                    </div>

                    <h1 className="pm-title">Premsi Premium Message</h1>

                    <div onClick={() => navigate("/user?id=" + pmitem[1]?.creator)} className="pm-creator-pill">
                      <div className="pm-creator-dot">
                        <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: 13, height: 13, color: '#fff' }}>
                          <circle cx="12" cy="8" r="4"/>
                          <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
                        </svg>
                      </div>
                      <span className="pm-creator-label">
                        {pmitem[1].type === "image" ? "Image" : pmitem[1].type === "video" ? "Video" : "PDF"} by <em>{pmitem[1]?.creatordisplayname}</em>
                      </span>
                    </div>

                    {pmitem[1]?.amountfiles != null && (
                      <div className="pm-chip">
                        {pmitem[1].type === "video" ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/>
                          </svg>
                        ) : pmitem[1].type === "image" ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
                          </svg>
                        ) : (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                          </svg>
                        )}
                        {pmitem[1]?.amountfiles} {pmitem[1].type === "video" ? "Video" : pmitem[1].type === "image" ? "Image" : "PDF"}
                      </div>
                    )}
                  </div>

                  {/* ── Card Body ── */}
                  <div className="pm-card-body">

                    {/* Unlocked media (free / retrieved) */}
                    {loadingpm ? (
                      <div className="pm-media-locked pm-media-locked--center">
                        <Oval height={40} width={40} color="white" wrapperStyle={{ display: "flex", alignItems: "center", justifyContent: "center" }} wrapperClass="" visible={true} ariaLabel='oval-loading' secondaryColor="white" strokeWidth={5} strokeWidthSecondary={5} />
                      </div>
                    ) : isnotfree ? (
                      <div className="pm-media-locked pm-media-locked--center">
                        <h4 style={{ color: '#fff' }}>This Premium Message is not free</h4>
                      </div>
                    ) : retrievedpm != null ? (
                      retrievedpm?.data.type === "image" ? (
                        <div className="pm-media-retrieved">
                          {arrayofmedia.map((mappedimage, i) => (
                            <div key={i} style={{ height: 200, aspectRatio: '12/16', borderRadius: 20, backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <img loading="lazy" src={mappedimage[1]} style={{ pointerEvents: "none", height: "100%", aspectRatio: '12/16', borderRadius: 20, objectFit: "contain" }} onError={(e) => (e.target.src = require('../../images/pblue-min.webp'))} onClick={() => null} alt={"Premsi Premium Message " + retrievedpm?.data.description} />
                            </div>
                          ))}
                        </div>
                      ) : retrievedpm?.data.type === "video" ? (
                        <div className="pm-media-retrieved">
                          {arrayofmedia.map((mappedvideo, i) => (
                            <div key={i} style={{ height: 200, aspectRatio: '12/16', overflow: "hidden", borderRadius: 20, backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <VideoPlayerBoughtPM style={{ pointerEvents: "none", height: "100%", backgroundColor: "white", aspectRatio: '12/16', borderRadius: 20 }} src={mappedvideo[0]} />
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ pointerEvents: "none" }} className="Example__container" ref={setContainerRef}>
                          <div style={{ backgroundColor: "#009FFD", paddingLeft: 20, marginBottom: 10, display: "flex", alignItems: "center", justifyContent: "center", paddingRight: 20, paddingTop: 10, paddingBottom: 10, borderRadius: 15 }}>
                            <p style={{ color: "white", fontSize: 14 }}>Total {numPages} pages</p>
                          </div>
                          <div className="Example__container__document">
                            <Document options={options} onLoadSuccess={onDocumentLoadSuccess} file={retrievedpm?.data.media}>
                              {Array.apply(null, Array(numPages)).map((x, i) => i + 1).map((page) => (
                                <Page key={page} pageNumber={page} renderTextLayer={false} renderAnnotationLayer={false} width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth} style={{ marginBottom: 30 }} />
                              ))}
                            </Document>
                          </div>
                        </div>
                      )
                    ) : (
                      /* ── Locked media preview ── */
                      <div className="pm-media-locked">
                        {pmitem[1].uploadedblurredimage ? (
                          <img loading="lazy" src={pmitem[1].uploadedblurredimage} className="pm-media-blurred" onError={(e) => (e.target.src = require('../../images/pblue-min.webp'))} alt={"Premsi Premium Message " + pmitem[1]?.description} />
                        ) : (
                          <div className="pm-media-bg" />
                        )}
                        <div className="pm-media-overlay">
                          <div className="pm-lock-pill">
                            <HiOutlineLockClosed size={16} />
                            <span>Locked Content</span>
                          </div>
                          <span className="pm-media-sub">Purchase to unlock</span>
                        </div>
                        {pmitem[1]?.amountfiles != null && (
                          <div className="pm-media-badge">
                            {pmitem[1].type === "video" && (
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/>
                              </svg>
                            )}
                            {pmitem[1]?.amountfiles}
                          </div>
                        )}
                      </div>
                    )}

                    {/* ── Message / description preview ── */}
                    <div className="pm-message-card">
                      <div className="pm-accent-bar" />
                      <div className="pm-message-text">{pmitem[1]?.description}</div>
                    </div>

                    {/* ── Action row ── */}
                    <div className="pm-action-row">
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText("www.premsi.com/pm?id=" + pmitem[0]);
                          setcopiedlink(true);
                          setTimeout(() => setcopiedlink(false), 2000);
                        }}
                        className={`pm-btn pm-btn-share${copiedlink ? ' pm-btn-share--copied' : ''}`}
                      >
                        {copiedlink ? (
                          <>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="20 6 9 17 4 12"/>
                            </svg>
                            Copied!
                          </>
                        ) : (
                          <>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                              <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                            </svg>
                            Share
                          </>
                        )}
                      </button>
                      <div className="pm-btn pm-btn-x">
                        <TwitterShareButton
                          onLoad={function noRefCheck() {}}
                          options={{ buttonHashtag: undefined, screenName: undefined, size: 'large', text: "See this new Premsi Premium Message 🔥🧿" }}
                          placeholder={<div style={{ backgroundColor: 'transparent', color: 'white', padding: 10, textAlign: "center", fontSize: 11 }}>loading x</div>}
                          url={`https://www.premsi.com/pm?id=${pmitem[0]}`}
                        />
                      </div>
                    </div>

                    {/* ── Buy / payment section ── */}
                    {loading ? (
                      <div className="pm-btn-buy pm-btn-buy--loading">
                        <Oval height={36} width={36} color="#1c0c00" wrapperStyle={{ display: "flex", alignItems: "center", justifyContent: "center" }} wrapperClass="" visible={true} ariaLabel='oval-loading' secondaryColor="#1c0c00" strokeWidth={5} strokeWidthSecondary={5} />
                      </div>
                    ) : buypm ? (
                      auth.currentUser === null || auth.currentUser === undefined ? (
                        <div className='buypmbtn'>
                          <p style={{ color: "white", marginBottom: 10, fontSize: 14, fontWeight: "bold", borderRadius: 10, paddingTop: 10, paddingBottom: 10, paddingRight: 20, paddingLeft: 20, textAlign: "center", backgroundColor: "rgba(255,255,255,0.4)" }}>{pmitem[1].price}$</p>
                          <p style={{ width: "80%", color: "white", marginBottom: 15 }}>We will send the premium message to this email and with the password you can access it. Don't share it, otherwise other people can access your account.</p>
                          <input disabled={showpp} style={{ border: "none", color: "white", fontSize: 15, borderRadius: 20, height: 40, textAlign: "center", width: 250, backgroundColor: "rgba(255,255,255,0.4)" }} type="email" placeholder='Your E-Mail' onChange={(e) => setemail(e.target.value)} />
                          <input disabled={showpp} style={{ border: "none", marginTop: 15, marginBottom: 10, color: "white", fontSize: 15, borderRadius: 20, height: 40, textAlign: "center", width: 250, backgroundColor: "rgba(255,255,255,0.4)" }} type="text" placeholder='Set a password' onChange={(e) => setpw(e.target.value)} />
                          {isemail ? null : <p className='noemail'>Please insert a real e-mail and password for purchasing</p>}
                          {isemail && pw !== "" && showpp === false ?
                            <div onClick={() => setshowpp(true)} className='buypmbtnendpp'><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Buy</p></div>
                            : <div onClick={() => setshowpp(false)} className='buypmbtnendpp'><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Back</p></div>
                          }
                          {showpp ? (
                            <>
                              <div onClick={() => setbuymethod(1)} className='buypmbtnend'><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Buy with Paypal 💰</p></div>
                              <div onClick={() => setbuymethod(2)} className='buypmbtnend' style={{ marginBottom: 0 }}><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Buy with Credit Card 💰</p></div>
                              <div onClick={() => navigate("/alternativehomepage")} className='buypmbtnend' style={{ marginBottom: 10 }}><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Sign Up, save your payment method and use faster checkout!</p></div>
                            </>
                          ) : null}
                          {buymethod === 0 ? null : <p style={{ fontSize: 22, marginBottom: 10, color: "white" }}>⬇</p>}
                          {buymethod === 0 ? null : (
                            buymethod === 1 ?
                              <PaypalBuyImmediatelyBtnNotLoggedIn pmitem={pmitem} price={Number(pmitem[1].price)} email={email} pw={pw} />
                              :
                              <Elements stripe={stripePromise} options={{ mode: "payment", amount: 122, currency: "usd" }}>
                                <StripeBuyImmediatelyBtnNotLoggedIn pmitem={pmitem} price={Number(pmitem[1].price)} email={email} pw={pw} />
                              </Elements>
                          )}
                        </div>
                      ) : (
                        <div className='buypmbtn'>
                          {boughtsuccess ? (
                            <>
                              <p style={{ color: "white", marginBottom: 7, fontSize: 14 }}>You successfully bought this premium message.</p>
                              <p style={{ color: "white", marginBottom: 7, fontSize: 14 }}>Download the Premsi <a href="app" style={{ color: "white" }}>App</a> to view it in your profile 🎉</p>
                            </>
                          ) : (
                            <>
                              <div onClick={() => setbuymethod(1)} className='buypmbtnend'><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Buy with Paypal 💰</p></div>
                              <div onClick={() => setbuymethod(2)} className='buypmbtnend' style={{ marginBottom: 0 }}><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Buy with Credit Card 💰</p></div>
                              <div onClick={() => setbuymethod(3)} className='buypmbtnend' style={{ marginBottom: 10 }}><p style={{ color: "white", fontSize: 14, fontWeight: "bold" }}>Pay with your saved Payment Method 💰</p></div>
                              {buymethod === 0 ? null : <p style={{ fontSize: 22, marginBottom: 10, color: "white" }}>⬇</p>}
                              {buymethod === 0 ? null : (
                                buymethod === 1 ?
                                  <PaypalBuyImmediatelyBtn pmitem={pmitem} price={Number(pmitem[1].price)} />
                                  : (buymethod === 2 ?
                                    (loadingClientSecret ?
                                      <Oval height={40} width={40} color="#009FFD" wrapperStyle={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "center" }} wrapperClass="" visible={true} ariaLabel='oval-loading' secondaryColor="white" strokeWidth={5} strokeWidthSecondary={5} />
                                      :
                                      <Elements stripe={stripePromise} options={{ mode: "payment", amount: 100, currency: "usd" }}>
                                        <StripeBuyImmediatelyBtn pmitem={pmitem} stripeUser={stripeuser} price={Number(pmitem[1].price)} />
                                      </Elements>
                                    )
                                    :
                                    <InjectedPayWithSavedCard pmitem={pmitem} amount={Number(pmitem[1].price)} />
                                  )
                              )}
                            </>
                          )}
                        </div>
                      )
                    ) : (
                      <div
                        onClick={() => (Number(pmitem[1].price) === 0 && (auth.currentUser === null || auth.currentUser === undefined) ? freenotloggedin() : (Number(pmitem[1].price) === 0 ? freeloggedin() : setbuypm(true)))}
                        className="pm-btn-buy"
                      >
                        {Number(pmitem[1].price) === 0 ? (
                          <><span>Get it for</span><span className="pm-price-chip">Free</span><span>😇</span></>
                        ) : (
                          <><span>Buy for</span><span className="pm-price-chip">{pmitem[1].price}$</span><span>💰</span></>
                        )}
                      </div>
                    )}

                    {loadingerror && (
                      <p style={{ textAlign: "center", color: "red", fontSize: 13, marginTop: 5 }}>There was an error retrieving this Premium Message from our servers.</p>
                    )}

                  </div>{/* end pm-card-body */}

                  {/* ── Divider ── */}
                  <div className="pm-divider" />

                  {/* ── Footer ── */}
                  <div className="pm-card-footer">
                    <p className="pm-footer-text">
                      You can also buy this Premium Message in our <a href="app">App</a>
                    </p>
                  </div>
                </>
            )
          }
        </div>
      </div>
      <Footer />

    </div >
  )
}

export default PremiumMessage


